<template>
  <div class="d-flex flex-row justify-content-between pointer" @click="logout">
    <span v-if="logoutError" role="alert" class="logout-error">{{ logoutError }}</span>
    <div class="p-relative mr-2">
      <div class="settings-icon">
        <img width="12" height="12" src="@/images/settings-icon.png" alt="">
      </div>
      <img class="broker-image" :src="getProfileImage()" width="50" alt="">
    </div>
  </div>
</template>

<script>
import clientFilters from "../../mixins/clientFilters";
import { logoutUser } from "../../services/brokerService";
import {notifyWorkspaceLogout} from "@/utils/workspaceExternalNavigation";
import imagesConvert from "../../mixins/imagesConvert";

export default {
  name: "UserProfile",
  mixins: [
    clientFilters,
    imagesConvert
  ],
  methods: {
    // logout () {
    //   this.$router.push({name: "KartaNastavenia"});
    // },
    async logout () {
       if (this.loggingOut) return;
       this.loggingOut = true; this.logoutError = '';
       try { await logoutUser(); }
       catch { this.loggingOut = false; this.logoutError = 'Odhlásenie sa nepodarilo. Skúste znova.'; return; }
       if (notifyWorkspaceLogout()) return;
       this.$store.commit("userState/setLogged", {logged: false});
       this.$store.commit("userState/setMe", null);
       this.$store.commit("appState/setEntryUrl", null);
       this.$router.replace({name: "Landing"}).catch(() => {});
    },
    getProfileImage () {
      if (this.me.profile_image) {
        return this.me.profile_image;
      } else {
        return require("@/images/logo-avatar-not-set.png");
      }
    },
  },
  created () {
    this.me = this.$store.getters["userState/getMe"];
  },
  data: () => ({
    me: null, loggingOut: false, logoutError: ''
  }),
}
</script>

<style lang="scss" scoped>
.logout-error{position:absolute;bottom:70px;left:0;width:260px;padding:12px;background:var(--app-surface);color:var(--app-text);border:1px solid var(--app-border);border-radius:10px}
.settings-icon {
  position: absolute;
  top: 60%;
  right: 65%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  width: 20px;
  height: 20px;
}
</style>
